import { render, staticRenderFns } from "./MarginTable.vue?vue&type=template&id=64598954&scoped=true&"
import script from "./MarginTable.vue?vue&type=script&lang=js&"
export * from "./MarginTable.vue?vue&type=script&lang=js&"
import style0 from "./MarginTable.vue?vue&type=style&index=0&id=64598954&scoped=true&lang=css&"
import style1 from "./MarginTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64598954",
  null
  
)

export default component.exports